var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.89 13.8h6.75V12H7.89Zm0-2.7h11.85V9.3H7.89Zm0-2.7h11.85V6.6H7.89Zm-2.49 12a1.727 1.727 0 0 1-1.26-.54 1.727 1.727 0 0 1-.54-1.26V1.8A1.727 1.727 0 0 1 4.14.54 1.727 1.727 0 0 1 5.4 0h16.8a1.727 1.727 0 0 1 1.26.54A1.727 1.727 0 0 1 24 1.8v16.8a1.727 1.727 0 0 1-.54 1.26 1.727 1.727 0 0 1-1.26.54Zm0-1.8h16.8V1.8H5.4ZM1.8 24a1.727 1.727 0 0 1-1.26-.54A1.727 1.727 0 0 1 0 22.2V3.6h1.8v18.6h18.6V24ZM5.4 1.8Z",
    "data-name": "library_books_FILL0_wght400_GRAD0_opsz48 (1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleDoc);
export default __webpack_public_path__ + "static/media/double-doc.3aa232c7933337db0a020d4f3b806df0.svg";
export { ForwardRef as ReactComponent };